import { types } from './reducer'
import { RSAA } from 'redux-api-middleware'

export const actions = {
  getRevenue: (data) => dispatch => dispatch({

  }),
  // Переход на адрес. Без options: заменяет текущий запис истории (как раньше). options:
  //   push   добавить запись: «назад» вернёт на экран, с которого перешли;
  //   state  что запомнить в записи (например { fromList: true });
  //   back   имя метки из state: если текущий экран открыли с неё, вернуться назад по истории
  //          (так после «Сохранить» «назад» ведёт на экран до формы), иначе заменить запись.
  redirectTo: (value, options) => {
    return ({
      type: types.REDIRECT_TO,
      payload: options ? { to: value, ...options } : value
    })
  },
  resetRedirect: () => (
    {
      type: types.RESET_REDIRECT
    }),
  showAlert: (data) => {
    return ({
      type: types.SHOW_ALERT,
      payload: data
    })
  },
  hideAlert: (data) => {
    return ({
      type: types.HIDE_ALERT,
      payload: data
    })
  }
}